
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { mergeStyleSets } from 'office-ui-fabric-react/lib/Styling';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import { getVymeraStringWithUnitHa } from '../../common/common/iskn/vymera';
import Text from '../../common/client/components/Text';

import { getToken } from '../../reducers/auth';
import { getProjectId } from '../../reducers/project';
import categoryGetActions from '../../sagas/category';
import listGetActions from '../../sagas/list';
import selectionGetActions from '../../sagas/selection';
import DialogConfirm from '../common/DialogConfirm';
import DialogSetCategoryItem from './DialogSetCategoryItem';
import ObjectInfoTitle from './ObjectInfoTitle';
import ObjectInfoValues from './ObjectInfoValues';
import ToolbarCommandButton from './ToolbarCommandButton';

const classNames = mergeStyleSets({
    root: {
        borderBottom: '1px solid #dddddd',
        paddingBottom: 8
    }
});

const ObjectInfoSelection = (props) => {
    const dispatch = useDispatch();
    const categoryActions = categoryGetActions(dispatch);
    const listActions = listGetActions(dispatch);
    const selectionActions = selectionGetActions(dispatch);

    const token = useSelector(state => getToken(state));
    const projectId = useSelector(state => getProjectId(state));
    const selection = useSelector(state => state.selection);

    const actualList = useSelector(state => {
        return state.list.actualList;
    });

    const category = useSelector(state => {
        return state.category;
    });

    useEffect(() => {
        if (!selection.loaded && !selection.loading) {
            selectionActions.selectionGet(token, projectId);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleAddListClick = () => {
        listActions.listAdd(token, projectId, actualList.name);
    }

    const handleClearClick = async () => {
        const message = `Opravdu chcete odebrat všechny parcely z výběru?`;

        let confirm = await DialogConfirm.show(message);
        if (confirm) {
            selectionActions.selectionClear(token, projectId);
        }
    }

    const handleRemoveListClick = async () => {
        const message = `Opravdu chcete odebrat vybrané parcely z aktuálního seznamu?`;

        let confirm = await DialogConfirm.show(message);
        if (confirm) {
            listActions.listRemove(token, projectId, actualList.name);
        }
    }

    const handleSetCategoryClick = async () => {
        let categoryName = category.actualCategoryFullName.split(':')[1];
        let categoryItems = category.categoryItems[categoryName];
        let data = await DialogSetCategoryItem.show(categoryItems);
        if (data) {
            switch (data.operation) {
                case 'SET':
                    categoryActions.categorySet(
                        token, projectId, actualList.name,
                        categoryName,
                        data.categoryItem
                    );
                    break;
                case 'ADDSET':
                    categoryActions.categoryAddSet(
                        token, projectId, actualList.name,
                        categoryName,
                        data.categoryItemColor,
                        data.categoryItemTitle
                    );
                    break;
                case 'REMOVE':
                    categoryActions.categoryRemove(
                        token, projectId, actualList.name,
                        categoryName
                    );
                    break;
                default:
                    // nop;
                    break;
            }
        }
    }

    const disabled = selection.loaded
        ? (selection.count === 0)
        : true;

    return (
        <div className={classNames.root}>
            <Stack>
                <Stack.Item>
                    <ObjectInfoTitle title="VÝBĚR" />
                </Stack.Item>
                <Stack.Item>
                    {selection.loaded
                        ? <Stack>
                            <Stack.Item>
                                <ObjectInfoValues
                                    items={[
                                        {
                                            title: 'Počet parcel',
                                            value: `${selection.count}`
                                        },
                                        {
                                            title: 'Výměra parcel',
                                            value: getVymeraStringWithUnitHa(selection.vymera)
                                        }
                                    ]}
                                />
                            </Stack.Item>
                            <Stack.Item>
                                <ToolbarCommandButton items={[
                                    {
                                        text: 'Seznam',
                                        title: 'Operace se seznamem parcel',
                                        disabled: disabled,
                                        items: [
                                            {
                                                text: 'Do seznamu',
                                                title: 'Přidat vybrané parcely do seznamu',
                                                onClick: handleAddListClick
                                            },
                                            {
                                                text: 'Ze seznamu',
                                                title: 'Odebrat vybrané parcely ze seznamu',
                                                onClick: handleRemoveListClick
                                            }
                                        ]
                                    },
                                    {
                                        title: 'Operace s kategoriemi',
                                        text: 'Kategorie',
                                        disabled: disabled,
                                        items: [
                                            {
                                                text: 'Nastavit',
                                                title: 'Nastavit kategorie pro vybrané parcely',
                                                onClick: handleSetCategoryClick
                                            }
                                        ]
                                    },
                                    {
                                        onClick: handleClearClick,
                                        title: 'Odebrat všechny parcely z výběru',
                                        text: 'Vyčistit',
                                        disabled: disabled
                                    }
                                ]}/>
                            </Stack.Item>
                        </Stack>
                        : <Text>Načítám data...</Text>
                    }
                </Stack.Item>
            </Stack>
        </div>
    );
}

export default ObjectInfoSelection;
